import styled from 'styled-components';

export const Container = styled.div`
  .modal-header {
    background-color: ${(props) => props.theme.$dark};
    color: ${(props) => props.theme.$white};
    text-align: center;
    display: block;
  }

  .modal-footer {
    justify-content: center !important;
  }
  .modal-title {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
  }

  .close {
    color: ${(props) => props.theme.$white};
  }
`;
